import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useAuth, hasPermission } from "@/lib/auth";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Link } from "wouter";

export function ReceivedBeforeApprovalCount() {
  const { user, roles, currentWorkspace } = useAuth();
  const { i18n } = useTranslation();
  const allowed = hasPermission(user, "purchase_orders.view", roles)
    && (hasPermission(user, "procurement.approve_po", roles) || hasPermission(user, "purchase_orders.approve", roles));
  const { data } = useQuery<{ count: number }>({
    queryKey: ["/api/purchase-orders/received-before-approval-count", currentWorkspace?.id, user?.id, user?.managedLocationIds],
    queryFn: () => api.purchaseOrders.receivedBeforeApprovalCount(currentWorkspace!.id),
    enabled: !!user && !!currentWorkspace?.id && allowed,
    refetchInterval: 60_000,
  });
  if (!allowed || !data?.count) return null;
  const label = i18n.language.startsWith("ar") ? "تم الاستلام قبل الموافقة — بانتظار المراجعة" : "Received before approval — unreviewed";
  return <Link href="/purchase-orders?preset=received-before-approval" aria-label={`${label}: ${data.count}`} title={label}>
    <Badge variant="secondary" data-testid="received-before-approval-count">{data.count}</Badge>
  </Link>;
}